import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/system/server-data/offline-status");
